console.log('PURCHASE ENGINE LOADED');

class ProductPurchase {
  constructor(container) {

  this.container = container;

  this.rows = [
    ...container.querySelectorAll('[data-variant-row]')
  ];

  this.totalPriceEl = container.querySelector(
    '[data-total-price]'
  );

  this.atcButton = container.querySelector(
    '[data-add-to-cart]'
  );

  this.currencyFormat =
    window.Shopify?.money_format || '${{amount}}';

  /* =========================================
     QUANTITY MODAL
  ========================================= */

  this.form = this.container.closest('form');

  this.modal = document.querySelector(
    '[data-qty-modal]'
  );

  this.modalInput = document.querySelector(
    '[data-qty-modal-input]'
  );

  this.currentRow = null;

  this.init();

}

  /* =====================================================
     INIT
  ===================================================== */

  init() {

    this.bindQuantityButtons();

    this.bindInputs();

    this.bindQtyModal();

    this.bindAddToCart();

    this.updateTotal();

  }

   /* =====================================================
     GET ACTIVE QUANTITY FIELD
  ===================================================== */

  isMobile() {
    return window.matchMedia('(max-width:1024px)').matches;
}

getQtyField(row) {

    return this.isMobile()
        ? row.querySelector('[data-qty-input-mobile]')
        : row.querySelector('[data-qty-input]');

}

  /* =====================================================
     QUANTITY BUTTONS
  ===================================================== */

  bindQuantityButtons() {

    this.rows.forEach((row) => {

      const minusBtn = row.querySelector('[data-qty-minus]');
      const plusBtn = row.querySelector('[data-qty-plus]');
      const input = this.getQtyField(row);

      const max = parseInt(input.max || 9999);

      minusBtn?.addEventListener('click', () => {

        let value = parseInt(input.value || 0);

        value--;

        if (value < 0) value = 0;

        input.value = value;

        this.updateTotal();

      });

      plusBtn?.addEventListener('click', () => {

        let value = parseInt(input.value || 0);

        value++;

        if (value > max) value = max;

        input.value = value;

        this.updateTotal();

      });

    });

  }

  /* =====================================================
     INPUTS
  ===================================================== */

  bindInputs() {

  this.rows.forEach((row) => {

    const input = this.getQtyField(row);

    /* =========================================
       MOBILE SELECT
    ========================================= */

    if (input.tagName === 'SELECT') {

      input.addEventListener('change', () => {

        if (input.value === '5plus') {

          this.openQtyModal(row);
          return;

        }

        // Keep the desktop input as the real value
        row.querySelector('[data-qty-input]').value =
          input.value;

        this.updateTotal();

      });

      return;

    }

    /* =========================================
       DESKTOP INPUT
    ========================================= */

    const max = parseInt(input.max || 9999);

    input.addEventListener('focus', () => {

      input.select();

    });

    input.addEventListener('input', () => {

      let value = input.value.replace(/\D/g, '');

      value = parseInt(value || 0);

      if (value < 0) value = 0;

      if (value > max) value = max;

      input.value = value;

      this.updateTotal();

    });

    input.addEventListener('blur', () => {

      if (input.value === '') {
        input.value = 0;
      }

      this.updateTotal();

    });

  });

}


  openQtyModal(row){

    this.currentRow = row;

    this.modalInput.value =
        row.querySelector('[data-qty-input]').value || 5;

    this.modal.classList.add('is-open');

    this.modalInput.focus();

    this.modalInput.select();

}


bindQtyModal(){

    const ok =
        this.modal.querySelector('[data-qty-ok]');

    const cancel =
        this.modal.querySelector('[data-qty-cancel]');

    cancel.addEventListener('click',()=>{

        this.modal.classList.remove('is-open');

        this.currentRow
            .querySelector('[data-qty-input-mobile]')
            .value="0";

    });

    ok.addEventListener('click',()=>{

        const qty=Math.max(
            5,
            parseInt(this.modalInput.value)||5
        );

        this.currentRow
            .querySelector('[data-qty-input]')
            .value=qty;

        this.modal.classList.remove('is-open');

        this.updateTotal();

    });

}


  

  /* =====================================================
     TOTAL PRICE
  ===================================================== */

  updateTotal() {

    let total = 0;

    this.rows.forEach((row) => {

      const price = parseInt(
        row.dataset.variantPrice || 0
      );

      const qty = parseInt(
    row.querySelector('[data-qty-input]').value || 0
);

      total += price * qty;

    });

    this.totalPriceEl.innerHTML =
      this.formatMoney(total);

  }

  /* =====================================================
   FORMAT MONEY (INR)
===================================================== */

formatMoney(cents) {

  const amount = cents / 100;

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  }).format(amount);

}

  /* =====================================================
     ADD TO CART
  ===================================================== */

  bindAddToCart() {

    if (!this.atcButton) return;

    this.atcButton.addEventListener('click', async () => {

      const items = [];

      this.rows.forEach((row) => {

        const qty = parseInt(
    row.querySelector('[data-qty-input]').value || 0
);

        if (qty > 0) {

          items.push({
            id: parseInt(row.dataset.variantId),
            quantity: qty
          });

        }

      });

      console.log('ITEMS TO ADD:', items);

      if (!items.length) {

        this.shakeButton();

        return;

      }

      try {

        this.setLoading(true);

        const response = await fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: JSON.stringify({
    items: items,

    sections: document.querySelector(
      'cart-items-component'
    )?.dataset.sectionId
  })
});

        if (!response.ok) {

          const errorText = await response.text();

          console.error(
            'CART ERROR:',
            errorText
          );

          throw new Error(
            'Cart request failed'
          );

        }

        const data = await response.json();

        console.log(
          'ADDED TO CART SUCCESS:',
          data
        );

        /* =========================================
           FETCH UPDATED CART
        ========================================= */

        const cartResponse = await fetch(
          '/cart.js'
        );

        const cart = await cartResponse.json();

        console.log('UPDATED CART:', cart);

        /* =========================================
           DISPATCH NATIVE HORIZON EVENT
        ========================================= */

        document.dispatchEvent(
  new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: cart,
      sourceId: 'custom-product-pdp',
      data: {
        source: 'product-form-component',

        itemCount: items.reduce(
          (total, item) => total + item.quantity,
          0
        ),

        productId:
          this.container.dataset.productId || '',

        sections: data.sections
      }
    }
  })
);

        /* =========================================
           OPEN HORIZON CART DRAWER
        ========================================= */

        const cartDrawer = document.querySelector(
          'cart-drawer-component'
        );

        cartDrawer?.open?.();

        /* =========================================
           RESET INPUTS
        ========================================= */

        this.resetInputs();
        this.showAddedState();

      } catch (error) {

        console.error(error);

        this.showError();

      } finally {

  setTimeout(() => {

    this.setLoading(false);

  }, 10000);

}

    });

  }

  /* =====================================================
     LOADING STATE
  ===================================================== */

  setLoading(isLoading) {

    if (!this.atcButton) return;

    this.atcButton.disabled = isLoading;

    this.atcButton.innerHTML = isLoading
      ? 'ADDING...'
      : 'ADD TO CART';

  }

  /* =====================================================
     RESET INPUTS
  ===================================================== */

  resetInputs() {

    this.rows.forEach((row) => {

      const input = row.querySelector(
        '[data-qty-input]'
      );

      input.value = 0;

    });

    this.updateTotal();

  }

  /* =====================================================
   ADDED STATE
===================================================== */

showAddedState() {

  if (!this.atcButton) return;

  this.atcButton.innerHTML = 'ADDED TO CART';

  this.atcButton.classList.add('is-added');

}

  /* =====================================================
     SHAKE
  ===================================================== */

  shakeButton() {

    this.atcButton.classList.add(
      'is-shaking'
    );

    setTimeout(() => {

      this.atcButton.classList.remove(
        'is-shaking'
      );

    }, 500);

  }

  /* =====================================================
     ERROR
  ===================================================== */

  showError() {

    this.container.classList.add(
      'has-error'
    );

    setTimeout(() => {

      this.container.classList.remove(
        'has-error'
      );

    }, 3000);

  }

}

/* =========================================================
   INIT
========================================================= */

document.addEventListener('DOMContentLoaded', () => {

  document
    .querySelectorAll(
      '[data-product-purchase]'
    )
    .forEach((purchase) => {

      new ProductPurchase(purchase);

    });

});


/* =========================================
   RE-INIT SWYM
========================================= */

window.SwymCallbacks = window.SwymCallbacks || [];

window.SwymCallbacks.push(function(swym) {

  if (window._swat?.initializeActionButtons) {

    window._swat.initializeActionButtons();

  }

});